module.exports = __webpack_public_path__ + "static/img/active_vip_11.2135a1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/survey2/images/activity/active_vip_11.jpg
// module id = bAU4
// module chunks = 0